export function isAndroid () {
  const u = navigator.userAgent;
  if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
    return true;
  }
  return false;
}

export function isIos () {
  const u = navigator.userAgent;
  if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
      return true;
  }
  return false;
}

export function isWechat () {
  const u = navigator.userAgent;
  if (u.toLowerCase().indexOf("micromessenger") !== -1) {
      return true;
  }
  return false;
}

export function isIphoneX () {
  return /iphone/gi.test(window.navigator.userAgent)
    && window.devicePixelRatio
    && (window.devicePixelRatio === 2 || window.devicePixelRatio === 3)
    && window.screen.width === 375
    && window.screen.height === 812
}

export function isIphoneXSMax () {
  return /iphone/gi.test(window.navigator.userAgent)
    && window.devicePixelRatio
    && window.devicePixelRatio === 3
    && window.screen.width === 414
    && window.screen.height === 896
}

export function isIphoneXR () {
  return /iphone/gi.test(window.navigator.userAgent)
    && window.devicePixelRatio
    && window.devicePixelRatio === 2
    && window.screen.width === 414
    && window.screen.height === 896
}

export function isIphone12Mini() {
  return /iphone/gi.test(window.navigator.userAgent)
    && window.devicePixelRatio
    && window.devicePixelRatio === 3
    && window.screen.width === 360
    && window.screen.height === 780
}

export function isIphone12() {
  return /iphone/gi.test(window.navigator.userAgent)
    && window.devicePixelRatio
    && window.devicePixelRatio === 3
    && window.screen.width === 390
    && window.screen.height === 844
}

export function isIphone12ProMax() {
  return /iphone/gi.test(window.navigator.userAgent)
    && window.devicePixelRatio
    && window.devicePixelRatio === 3
    && window.screen.width === 428
    && window.screen.height === 926
}

export function isFringePhone () {
  return isIphoneX() || isIphoneXSMax() || isIphoneXR() || isIphone12Mini() || isIphone12() || isIphone12ProMax();
}

export function getBytesLength (str) {
  let totalLength = 0;
  for(let i = 0; i < str.length; i++) {
    if(str.charCodeAt(i) >255) {
      totalLength += 2;
    } else {
      totalLength += 1;
    }
  }
  return totalLength;
}
